import NumberHelper from '@/utils/NumberHelper';
import MapsMarkerHelper from '../helpers';
import ListingGroupMarkerRenderer from './ListingGroupMarkerRenderer';

export default class ListingsMarkerMapper {
  static createMarkerData(markersData) {
    if (!markersData) {
      return [];
    }

    return markersData.map((listing) => this.#createMarkerParams(listing));
  }

  static #createMarkerParams(listing) {
    const shortFirstListingPrice = NumberHelper.toShortNumber(listing.price);

    return {
      position: {
        lat: listing.lat,
        lng: listing.lon,
      },
      listing,
      icon: MapsMarkerHelper.getListingIcon(listing),
      labelContent: `$${shortFirstListingPrice}`,
      labelClass: 'labels',
      groupRenderer: ListingGroupMarkerRenderer,
    };
  }
}
